'use client';

import {
  Storytelling,
  type StorytellingCard,
} from '@/app/components/client/storytelling';
import {
  type DatoButtonBlock,
  type DatoModuleFormat,
} from '@/lib/datocms/types';

import type { FlexProps } from '@ironhack/design-system2/components';
import type { ReactElement } from 'react';

export type Header = {
  button: DatoButtonBlock | null;
  card: [StorytellingCard];
  subtitle: string;
  title: string;
};

type Props = { data: Header } & FlexProps;

export const Header = (props: Props): ReactElement => {
  const {
    data: { button, card, subtitle, title },
    ...flexProps
  } = props;

  const moduleFormat: [DatoModuleFormat] = [
    { background: 'transparent', spacingBottom: '120', spacingTop: '120' },
  ];
  const storytellingData = {
    columns: [
      {
        subtitle,
        title,
        ...(button && { button: [button] as [DatoButtonBlock] }),
      },
      { card },
    ],
    headingProps: { as: 'h1' as const },
    moduleFormat,
  };

  return <Storytelling as="header" data={storytellingData} {...flexProps} />;
};
